import { ExpandMore } from '@mui/icons-material';
import { Text } from '../text';
import {
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSummary,
  StyledHeaderContainer,
} from './styles';
import type { ReactNode } from 'react';
import { SafeMarkdown } from '../markdown/safe';
import { Divider, AccordionProps as MUIAccordionProps } from '@mui/material';

interface AccordionProps extends MUIAccordionProps {
  title: string;
  children: NonNullable<ReactNode>;
  padding?: number;
  flexDirection?: 'row-reverse' | 'row' | 'column' | 'column-reverse';
  expandIcon?: ReactNode;
  tag?: ReactNode;
}

export const Accordion = ({
  title,
  children,
  padding,
  flexDirection,
  expandIcon,
  tag,
  ...rest
}: AccordionProps) => {
  return (
    <StyledAccordion variant="outlined" defaultExpanded disableGutters {...rest}>
      <StyledAccordionSummary
        expandIcon={expandIcon || <ExpandMore sx={{ color: 'text.primary' }} />}
        padding={padding}
        flexDirection={flexDirection}
      >
        <StyledHeaderContainer>
          <Text variant="h6" color="text.primary">
            <SafeMarkdown text={title} />
          </Text>

          {tag}
        </StyledHeaderContainer>
      </StyledAccordionSummary>
      <Divider variant="fullWidth" />

      <StyledAccordionDetails padding={padding}>{children}</StyledAccordionDetails>
    </StyledAccordion>
  );
};
